import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router'
import { Layout } from '../../components'
import { Routes } from '../../constants'
import Pages from './SelfServe.pages'

interface SelfServeRouteParams {
    estate: string;
    page: string;
}

export default function DesktopHeader() {
    const { t } = useTranslation()
    const location = useLocation()
    const { estate } = useParams<SelfServeRouteParams>()
    const activePage = Pages.find(({ path }) => {
        const builtPath = Routes.buildRoute(path, { estate })
        return location.pathname.includes(builtPath)
    })

    return (
        <>
            {t('self-serve')} &gt; {activePage ? t(activePage.i18nKey) : t('self-serve-promos')}
            <Layout.Tabs>
                {Pages.map(({ path, icon, isDisabled, i18nKey }) => {
                    const builtPath = Routes.buildRoute(path, { estate })
                    const isActive = location.pathname.includes(builtPath)

                    return (
                        <Layout.Tab
                            active={isActive}
                            key={path}
                            to={builtPath}
                            disabled={isDisabled}
                        >
                            <img src={icon} alt="" />
                            {t(i18nKey)}
                        </Layout.Tab>
                    )
                })}
            </Layout.Tabs>
        </>
    )
}
